export const tableData = [
  {
    acesso: '0',
    afastado: '0',
    ativo: '1',
    demitido: '0',
    eventual: '0',
    mesAno: '07/2018',
    statusMov: 'N/A',
    substituto: '0',
    total: '1',
    transferido: '0'
  },
  {
    acesso: '0',
    afastado: '0',
    ativo: '3',
    demitido: '0',
    eventual: '0',
    mesAno: '07/2018',
    statusMov: 'N/A',
    substituto: '0',
    total: '1',
    transferido: '0'
  },
  {
    acesso: '0',
    afastado: '0',
    ativo: '5',
    demitido: '0',
    eventual: '0',
    mesAno: '07/2018',
    statusMov: 'N/A',
    substituto: '0',
    total: '1',
    transferido: '0'
  }
]
